import { motion, useInView } from "framer-motion";
import { useRef } from "react";

interface FadeInSectionProps {
  children: React.ReactNode;
  delay?: number;
  duration?: number;
  direction?: "up" | "left" | "right";
}

const FadeInSection: React.FC<FadeInSectionProps> = ({
  children,
  delay = 0.2,
  duration = 0.8,
  direction = "up",
}) => {
  const ref = useRef(null);
  const inView = useInView(ref, {
    margin: "0px 0px -15% 0px",
    // 👇 Set once to false for repeated animation
    once: false,
  });

  const variants = {
    hidden: {
      opacity: 0,
      y: direction === "up" ? 40 : 0,
      x: direction === "left" ? -40 : direction === "right" ? 40 : 0,
    },
    visible: {
      opacity: 1,
      y: 0,
      x: 0,
      transition: {
        duration,
        ease: "easeOut",
        delay,
      },
    },
  };

  return (
    <motion.div
      ref={ref}
      variants={variants}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
    >
      {children}
    </motion.div>
  );
};

export default FadeInSection;
